<script setup lang="ts">
const email = 'nathalie.gottvalles.psy@gmail.com'
const phoneDisplay = '06 30 49 13 19'
const phoneTel = '+33630491319'
</script>

<template>
  <section id="contact" class="relative overflow-hidden py-24 px-6 md:px-12">
    <div class="absolute inset-0 pointer-events-none" aria-hidden="true">
      <div class="dandelion dandelion-1 absolute top-[8%] right-[5%] w-28 h-36 sm:w-36 sm:h-44 rotate-[-6deg]" />
      <div class="dandelion dandelion-3 absolute bottom-[10%] left-[4%] w-24 h-32 sm:w-32 sm:h-40 rotate-[8deg]" />
    </div>
    <div class="relative max-w-3xl mx-auto flex flex-col gap-12">
      <div class="flex flex-col gap-3 text-center">
        <p class="uppercase tracking-[0.3em] text-sm text-terracotta-600 dark:text-terracotta-400 font-medium">Autre
          moyen de contact</p>
        <h2 class="text-3xl md:text-4xl text-stone-900 dark:text-stone-50">Me contacter directement</h2>
        <p class="text-base md:text-lg text-stone-600 dark:text-stone-300 leading-relaxed max-w-2xl mx-auto">
          Si vous préférez échanger avant de réserver un créneau, écrivez-moi ou appelez-moi.
        </p>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <a :href="`tel:${phoneTel}`" :aria-label="`Appeler le ${phoneDisplay}`"
          class="card-hover flex flex-col gap-4 p-6 rounded-xl bg-white/70 dark:bg-stone-900/60 border border-stone-200 dark:border-stone-800 backdrop-blur-sm">
          <div
            class="w-12 h-12 rounded-lg bg-terracotta-100 dark:bg-terracotta-900/40 flex items-center justify-center">
            <i class="pi pi-phone text-xl text-terracotta-700 dark:text-terracotta-300" aria-hidden="true" />
          </div>
          <h3 class="text-lg text-stone-900 dark:text-stone-50">Téléphone</h3>
          <span class="text-stone-600 dark:text-stone-300 leading-relaxed">{{ phoneDisplay }}</span>
        </a>
        <a :href="`mailto:${email}`" :aria-label="`Envoyer un email à ${email}`"
          class="card-hover flex flex-col gap-4 p-6 rounded-xl bg-white/70 dark:bg-stone-900/60 border border-stone-200 dark:border-stone-800 backdrop-blur-sm">
          <div
            class="w-12 h-12 rounded-lg bg-terracotta-100 dark:bg-terracotta-900/40 flex items-center justify-center">
            <i class="pi pi-envelope text-xl text-terracotta-700 dark:text-terracotta-300" aria-hidden="true" />
          </div>
          <h3 class="text-lg text-stone-900 dark:text-stone-50">Email</h3>
          <span class="text-stone-600 dark:text-stone-300 leading-relaxed break-all">{{ email }}</span>
        </a>
      </div>
    </div>
  </section>
</template>
